// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"5c3b439f","223":"49e344c4","358":"66039477","390":"da86f608","453":"5c7a3aed","474":"4574af61","494":"5e66d3c3","503":"5d22bae3","626":"385d3de5","631":"3c8ed557","790":"41652a38","795":"025a2083","824":"cdc623aa","844":"e1d6dd3f","953":"57843de2"}[chunkId] + ".chunk.js";
};